import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs } from 'vue';
import { BookV1 } from '@ilteducation/content-registry-types';
import type { Language } from '@ilteducation/content-ref-data-types';
import { useRealmLabel } from '@/foundations/helpers/defaultRealms';
import { getAllRefData } from '@/data-provider/refDataProvider';

type BookChip = {
  id: string;
  label?: string;
  sublabel?: string;
};

type MarketGroup = {
  realm: string;
  books: BookChip[];
};

type Props = {
  book: BookV1;
  duplicateBooks: BookV1[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BookMarketsAvailability',
  props: {
    book: null,
    duplicateBooks: null
  },
  setup(__props: any) {

const props = __props as {
  book: BookV1;
  duplicateBooks: BookV1[];
}


const { book, duplicateBooks } = toRefs(props);

const tab = ref(null);
const availableLanguages = ref([] as Language[]);

getAllRefData('languages').then((languages) => {
  availableLanguages.value = languages.sort((a: Language, b: Language) => a.language.localeCompare(b.language));
});

const languageLabel = computed(
  () => (languageCode: string) =>
    availableLanguages.value.find((language) => language.languageCode === languageCode)?.language,
);

const groupsByMarket = computed<MarketGroup[]>(() => {
  const groupedBooks = new Map<string, BookV1[]>();
  duplicateBooks.value.forEach((duplicateBook) => {
    groupedBooks.set(duplicateBook.realm, [...(groupedBooks.get(duplicateBook.realm) || []), duplicateBook]);
  });

  return Array.from(groupedBooks.entries())
    .map(([realm, books]) => {
      const sortedBooks: BookChip[] = books
        .map((bookV1) => ({
          id: bookV1.id,
          label: languageLabel.value(bookV1.languages.mainLanguage),
          sublabel:
            bookV1.languages.secondaryLanguage && bookV1.languages.secondaryLanguage != bookV1.languages.mainLanguage
              ? languageLabel.value(bookV1.languages.secondaryLanguage)
              : undefined,
        }))
        .sort((a, b) => {
          if (!a.label || !b.label) {
            return 0;
          }
          return a.label.localeCompare(b.label);
        });

      return { realm, books: sortedBooks };
    })
    .sort((a, b) => {
      if (a.realm === book.value.realm) {
        return -1;
      }

      return a.realm.localeCompare(b.realm);
    });
});

const { realmLabel } = useRealmLabel();

return { __sfc: true,props, book, duplicateBooks, tab, availableLanguages, languageLabel, groupsByMarket, realmLabel }
}

})